import { render, staticRenderFns } from "./ruleConfigBox.vue?vue&type=template&id=2d604a14"
import script from "./ruleConfigBox.vue?vue&type=script&lang=js"
export * from "./ruleConfigBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports